export const EN = 'en'
export const ES = 'es'


// WEBPACK FOOTER //
// ./src/constants.js